import { PageShell } from "@/components/PageShell";
import { Services } from "@/components/Services";

export default function ServicesPage() {
  return (
    <PageShell>
      <Services />
    </PageShell>
  );
}
